import { LitElement, html, css } from "lit";
import "./accordeon-item.css";

export class Accordeon extends LitElement {
    static properties = {
        isOpen: { type: Boolean },
    }

    constructor() {
        super();
        this.isOpen = false;
    }

    firstUpdated(e) {
        !this.isOpen ? this.close() : this.open()
    }
   
    static styles = css`
    .header{
        display:flex;
        justify-content: space-between;
        padding: 20px 2px;
        cursor: pointer;
        background-color: var(--accordeon-header-background, #dedede);
    }
    .header:hover{
        opacity:0.75;
    }
    .header__title{
        flex: 1;
        padding-right:60px;
    }
    .header__wrapper{
        justify-content:space-between;
        flex: 1;
        display: flex;
    }
    .header__icon{
        transform : rotate(45deg);
        height: 24px;
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 250ms ease;
    }
    .header:hover .header__icon{
        transform: scale(1.2) rotate(45deg);
    }
    .--open .header:hover .header__icon,
    .--open  .header__icon{
        transform: rotate(0);
    }

    .body{
        height:100%;
        overflow : hidden;
        max-height: 0;
        border-top : 1px solid;
        transition: max-height 250ms ease;
        background-color: var(--accordeon-content-background, #f5f5f5);
    }
    
    .content{
        display:block;
        padding: 20px ;
        
    }
    `

    toggle() {
        this.isOpen ? this.close() : this.open()
    }

    open() {
        let contentHeight = this.shadowRoot.querySelector('.body .content').clientHeight;
        this.setIsOpen(true);
        this.shadowRoot.querySelector('.body').style.maxHeight = contentHeight + "px"
    }

    close() {
        this.setIsOpen(false);
        this.shadowRoot.querySelector('.body').style.maxHeight = 0
    }
    /**
     * 
     * @param {Boolean} val 
     */
    setIsOpen(val) {
        this.isOpen = val;
    }

    icon() {
        return html
            `<svg xmlns="http://www.w3.org/2000/svg" class="cross" width="14" height="14" viewBox="0 0 14 14">
    <path id="Union_1" data-name="Union 1"
        d="M-4274.929-5664.221l-6.364,6.363-.708-.707,6.364-6.364-6.364-6.364.708-.708,6.364,6.364,6.364-6.364.708.708-6.364,6.364,6.364,6.364-.708.707Z"
        transform="translate(4282 5672)" />
</svg>`
    }

    render() {
        return html`
        <div class="wrapper${this.isOpen ? ` --open` : ``} ">
            <div class="header" @click=${() => this.toggle()}>
                <div class="header__wrapper">
                    <div class="header__title">
                        <slot name="title"></slot>
                    </div>
                    <div class="header__icon"> ${this.icon()}</div>
                </div>
                <!-- <button>${this.isOpen ? 'fermer' : 'ouvrir'}</button> -->
            </div>
            <div class="body">
                <div class="content">
                    <slot name="content"></slot>
                </div>
            </div>
        </div>`
    }
}

customElements.define('accordeon-item', Accordeon)